'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (handler) {
    document.removeEventListener('fullscreenchange', handler);
    document.removeEventListener('webkitfullscreenchange', handler);
    document.removeEventListener('mozfullscreenchange', handler);
    document.removeEventListener('MSFullscreenChange', handler);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/dom/removeFullscreenEventListener.js
// module id = 83
// module chunks = 0